// https://en.wikipedia.org/wiki/Binary_search_algorithm
//
export var BinarySearch;
(function (BinarySearch) {
    BinarySearch.exact = (sorted, key, comparator) => {
        let l = 0 | 0;
        let r = sorted.length - 1;
        while (l <= r) {
            const m = (l + r) >>> 1;
            const cmp = comparator(sorted[m], key);
            if (cmp === 0) {
                return m;
            }
            if (cmp < 0) {
                l = m + 1;
            }
            else {
                r = m - 1;
            }
        }
        return -1;
    };
    BinarySearch.exactMapped = (sorted, key, comparator, map) => {
        let l = 0 | 0;
        let r = sorted.length - 1;
        while (l <= r) {
            const m = (l + r) >>> 1;
            const cmp = comparator(map(sorted[m]), key);
            if (cmp === 0) {
                return m;
            }
            if (cmp < 0) {
                l = m + 1;
            }
            else {
                r = m - 1;
            }
        }
        return -1;
    };
    BinarySearch.leftMost = (sorted, key, comparator) => {
        let l = 0 | 0;
        let r = sorted.length;
        while (l < r) {
            const m = (l + r) >>> 1;
            if (comparator(sorted[m], key) < 0) {
                l = m + 1;
            }
            else {
                r = m;
            }
        }
        return l;
    };
    BinarySearch.rightMost = (sorted, key, comparator) => {
        let l = 0 | 0;
        let r = sorted.length;
        while (l < r) {
            const m = (l + r) >>> 1;
            if (comparator(sorted[m], key) <= 0) {
                l = m + 1;
            }
            else {
                r = m;
            }
        }
        return r - 1;
    };
    BinarySearch.leftMostMapped = (sorted, key, comparator, map) => {
        let l = 0 | 0;
        let r = sorted.length;
        while (l < r) {
            const m = (l + r) >>> 1;
            if (comparator(map(sorted[m]), key) < 0) {
                l = m + 1;
            }
            else {
                r = m;
            }
        }
        return l;
    };
    BinarySearch.rightMostMapped = (sorted, key, comparator, map) => {
        let l = 0 | 0;
        let r = sorted.length;
        while (l < r) {
            const m = (l + r) >>> 1;
            if (comparator(map(sorted[m]), key) <= 0) {
                l = m + 1;
            }
            else {
                r = m;
            }
        }
        return r - 1;
    };
    BinarySearch.rangeMapped = (sorted, key, comparator, map) => [BinarySearch.leftMostMapped(sorted, key, comparator, map), BinarySearch.rightMostMapped(sorted, key, comparator, map)];
})(BinarySearch || (BinarySearch = {}));
